// @flow
// @jsx h

// External librairies
import { h } from "preact";

// Style
import styles from "./style.scss";
import { withStyles } from "elc-theme";

/**
 * Footer button container component
 * used to display the footer buttons in a common styled container
 */
const FooterButton = ({ children, getClassName }) => (
  <div class={getClassName("footerButton")}>{children}</div>
);

export default withStyles(FooterButton, styles);
